import { useFasten } from '@/hooks/useFasten';
import { PatientProfilePage } from '@/pages/PatientProfile';
import { createFileRoute } from '@tanstack/react-router';

const RouteComponent = (): React.ReactNode => {
  // oxlint-disable-next-line no-use-before-define
  const { patientId } = Route.useParams();

  useFasten();

  return <PatientProfilePage patientId={patientId} />;
};

export const Route = createFileRoute('/_auth/patients/$patientId/')({
  component: RouteComponent,
});
